var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "visit-absence" }, [
    _c(
      "div",
      { staticClass: "bg-white p-3 pr-md-4" },
      [
        _c("section-title", {
          staticClass: "visit-absence__section-title",
          attrs: {
            "container-class": "visit-absence__section-title__container",
            icon: "fas fa-user-cog",
            title: "Ausencia de Admisión",
            "title-class": "visit-absence__section-title__info"
          }
        }),
        _c("validation-observer", { ref: "visitAbsence" }, [
          _c("div", { staticClass: "row ml-md-4" }, [
            _c(
              "div",
              { staticClass: "col-12 col-md-2 mb-md-4 mb-2" },
              [
                _c("validation-provider", {
                  attrs: { rules: "required" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _c("custom-date-picker", {
                            attrs: {
                              "custom-error-msg":
                                "La fecha de la ausencia es requerida.",
                              error: errors[0],
                              label: "Fecha de la ausencia:",
                              "max-date": new Date(),
                              "min-date": _vm.data.linkedDate,
                              placeholder: "DD/MM/YYYY"
                            },
                            model: {
                              value: _vm.absence.date,
                              callback: function($$v) {
                                _vm.$set(_vm.absence, "date", $$v)
                              },
                              expression: "absence.date"
                            }
                          })
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-12 col-md-6 pl-md-5 mb-2" },
              [
                _c("validation-provider", {
                  attrs: { rules: "required" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _c("custom-drop-down", {
                            staticClass: "dropdown",
                            attrs: {
                              clearable: false,
                              "custom-error-msg":
                                "La razón de la ausencia es requerida.",
                              error: errors[0],
                              fieldkey: "id",
                              fieldname: "name",
                              label: "Razón de ausencia:",
                              options: _vm.data.reasons,
                              placeholder: "Seleccione"
                            },
                            model: {
                              value: _vm.absence.reason,
                              callback: function($$v) {
                                _vm.$set(_vm.absence, "reason", $$v)
                              },
                              expression: "absence.reason"
                            }
                          })
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            ),
            !_vm.disabledFormControl
              ? _c(
                  "div",
                  { staticClass: "col-12 col-md-4 mb-2" },
                  [
                    _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-input", {
                                  attrs: {
                                    "custom-error-msg":
                                      "El campo de Otros es requerido.",
                                    error: errors[0],
                                    label: "(Otro) Especifique:",
                                    type: "text"
                                  },
                                  model: {
                                    value: _vm.absence.reasonOther,
                                    callback: function($$v) {
                                      _vm.$set(_vm.absence, "reasonOther", $$v)
                                    },
                                    expression: "absence.reasonOther"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2087164966
                      )
                    })
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "col-12 mb-2" },
              [
                _c("validation-provider", {
                  attrs: { rules: "required" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _c("custom-text-area", {
                            staticClass: "visit-absence__text-area",
                            attrs: {
                              id: "comment",
                              "count-classes": ["d-block", "small-counter"],
                              "custom-error-msg": "El comentario es requerido.",
                              error: errors[0],
                              label: "Comentario:",
                              maxlength: 3000,
                              name: "comment",
                              "show-char-count": ""
                            },
                            model: {
                              value: _vm.absence.comment,
                              callback: function($$v) {
                                _vm.$set(_vm.absence, "comment", $$v)
                              },
                              expression: "absence.comment"
                            }
                          })
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-12 d-flex justify-content-end" },
              [
                _c("action-button", {
                  attrs: {
                    i: "fas fa-times-circle",
                    text: "Cancelar",
                    variant: "outline-danger mr-3"
                  },
                  on: { click: _vm.dispose }
                }),
                _c("action-button", {
                  attrs: {
                    i: "fa fa-save",
                    text: "Guardar",
                    variant: "success"
                  },
                  on: { click: _vm.save }
                })
              ],
              1
            )
          ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }